'use strict';

var _collection = require('common/models/base/collection');

var _collection2 = _interopRequireDefault(_collection);

var _teamMember = require('./team-member');

var _teamMember2 = _interopRequireDefault(_teamMember);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _collection2['default'].extend({

    apiEndpointAlias: 'teamMembers',

    /**
    */

    mixins: [require('common/models/mixins/collection')],

    /**
    */

    createModel: function createModel(properties) {
        properties.user = this.user;
        properties.notifier = this.notifier;
        return _teamMember2['default'].create(properties);
    },


    /**
    */

    loggedInUserCanModifyTeam: function loggedInUserCanModifyTeam() {
        // return !!this.filter(function(member) {
        //   return member.isLoggedInUser() && member.canModifyTeam();
        // }.bind(this)).length;
        return this.team.isOwner;
    },


    /**
    */
    getLoggedInUser: function getLoggedInUser() {
        return this.filter(function (member) {
            return member.isLoggedInUser();
        }.bind(this))[0];
    },


    /**
    */
    loggedInUserIsDeveloper: function loggedInUserIsDeveloper() {
        return !!this.filter(function (member) {
            return member.isLoggedInUser() && member.isDeveloper();
        }.bind(this)).length;
    },


    /**
    */
    loggedInUserIsAdmin: function loggedInUserIsAdmin() {
        return this.team.isOwner;
    },


    /**
    */

    addMember: function addMember(properties) {
        return this.createModel(properties).save();
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/models/team-members.js
 ** module id = 508
 ** module chunks = 0 1
 **/